import "./App.css";
import MyPortfolio from "./components";

function App() {
  return <MyPortfolio />;
}

export default App;
